import { render, staticRenderFns } from "./TopbarContacts.vue?vue&type=template&id=7df963f6&scoped=true"
import script from "./TopbarContacts.vue?vue&type=script&lang=js"
export * from "./TopbarContacts.vue?vue&type=script&lang=js"
import style0 from "./TopbarContacts.vue?vue&type=style&index=0&id=7df963f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df963f6",
  null
  
)

export default component.exports